/**
 * Picks v2 or v1 of the parameterized engagement-session-list base
 * (used by Recommended Sessions and Popular List). Both thin
 * wrappers import from here so a single flag flip swaps both pages.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import EngagementSessionListPage   from './EngagementSessionListPage';
import EngagementSessionListPageV2 from './v2/EngagementSessionListPageV2';

export default function EngagementSessionListPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? EngagementSessionListPageV2 : EngagementSessionListPage;
  return <Component {...props} />;
}
